export default "__VITE_ASSET__BxNEoG3l__"